import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { Switch, Popover, Icon, Menu } from 'antd';
import { Row, Col } from '../basic';
import Toolbar from './Toolbar';
import ConvenientQuery from "../filter";
// import ReportSelect from './ReportSelect';

import ReportSelect from '../basic/groupcondition';
let DimensionSetting = process.env.__CLIENT__ ? require('../dimension-setting/DimensionSetting.jsx').default : <div></div>;

import * as  eChartDemoData from '../echart/eChartDemoData';
import { Button } from 'antd/lib/radio';
export default class ListHeader extends Component {
  constructor(props) {
    super(props);

    const { query, filterId } = props.model.getParams();
    this.isStaticReport = query.reportId || query.subscriptionId || !filterId ? true : false;
    this.bSubscription = query.subscriptionId ? true : false;
    this.viewid = _.get(props.model.getParams(), 'query.viewid');

    this.bPublished = this.viewid ? true : false;

  }
  componentDidMount() {
    if (!this.refs.listHeader) return;
    this.height = findDOMNode(this.refs.listHeader).clientHeight;
    this.props.model.execute('listHeaderHeightUpdate', this.height);
    this.props.model.on('filterHeightUpdate', (filterName) => {
      const listHeaderDom = findDOMNode(this.refs.listHeader);
      if (!listHeaderDom) return;
      const height = listHeaderDom.clientHeight;
      if (!height || this.height === height) return;
      this.height = height;
      this.props.model.execute('listHeaderHeightUpdate', this.height, filterName);
    });
  }
  setQueryItems(viewModel, item) {
    const queryItems = viewModel.getCache('queryItems') || [];
    if (queryItems.indexOf(item) === -1)
      queryItems.push(item);
    viewModel.setCache('queryItems', queryItems);
  }
  publishMenu(model) {
    model.execute('publishMenu');
  }

  render() {
    const { meta, model, hasTree } = this.props;
    if (!meta.containers || this.bSubscription)
      return null;
    let filter = null, toolbar = null, solution = null, solution2 = null;
    meta.containers.map(item => {
      const config = {};
      if (item.cStyle) {
        try {
          Object.assign(config, JSON.parse(item.cStyle));
        } catch (e) {

        }
      }
      switch (item.cControlType.trim().toLocaleLowerCase()) {
        case 'convenientquery':
          if (this.isStaticReport) return;
          this.setQueryItems(model, 'filter');
          filter = <ConvenientQuery model={model} cols={item.iCols || 3} config={config} />
          break;
        case 'toolbar':
          if (this.bPublished == true) {
            item.controls = _.filter(item.controls, function (o) { return (o.cItemName != "btnsumSetting" && o.cItemName != "btnMenupublish") })
          }
          const extraProps = {};
          try {
            if (cb.rest.toolbarHotfix) {
              let showCount = item.controls && item.controls.length > 1 && item.controls[0].cItemName !== 'btnAdd' ? 0 : 1;
              if (config.hotfix === false) {
                showCount = undefined;
              } else {
                if (!cb.utils.isEmpty(config.showCount))
                  showCount = config.showCount;
                if (showCount === true)
                  showCount = items.controls.length;
              }
              extraProps.showCount = showCount;
            }
          } catch (e) {

          }
          toolbar = <Toolbar align='right' controls={item.controls} model={model} {...extraProps} />
          break;
        // case 'reportselect':
        //   if (this.isStaticReport) return;
        //   this.setQueryItems(model, 'schema');
        //   solution = <ReportSelect viewModel={model} viewid={this.viewid} />
        //   break;
        case 'reportselect':
          if (this.isStaticReport) return;
          this.setQueryItems(model, 'schema');
          let cStyle1 = item.cStyle || '{"hideShowInMobile":false,"hideScatterChart":false}';
          solution = <ReportSelect viewModel={model} viewid={this.viewid} cStyle={cStyle1} />
          // solution = <div className="LLLLLL" >
          //   <ReportSelect viewModel={model} viewid={this.viewid} />
          //   <DimensionSetting viewModel={model} />
          // </div>;
          break;
        case 'dimensionsetting':
          if (this.isStaticReport) return;
          // this.setQueryItems(model, 'schema');
          solution2 = <DimensionSetting viewModel={model} cSyle={item.cStyle} />
          break;
      }
    });
    // const secondCom = solution
    //   ? <Row>
    //     <div className="rpt-toolbar">{toolbar}</div>
    //     <div className="rpt-select">{solution}</div>
    //   </Row>
    //   : <Row><Col span={24}>{toolbar}</Col></Row>;
    let arr = [];
    if (solution || solution2) {
      arr.push(<div className="rpt-toolbar">{toolbar}</div>);
      if (solution)
        arr.push(<div className="rpt-select">{solution}</div>);
      if (solution2)
        arr.push(<div className="rpt-select2">{solution2}</div>);
    }
    else {
      arr.push(<Col span={24}>{toolbar}</Col>);
    }
    const secondCom = <Row>{arr} </Row>;
    return (
      <Row ref="listHeader" className="listheadRow">
        <Row>
          <Col span={24}>{filter}</Col>
        </Row>
        {secondCom}
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/ListHeader.jsx